// extracted by mini-css-extract-plugin
module.exports = {"container":"mm","disabled":"nm","bgBlack":"om","content":"pm","countdown":"qm","topCaption":"rm","topHeading":"sm","heading":"tm","copy":"um"};